import {h, Component} from 'preact';
import {Link} from 'react-router-dom';
import authContainer from '../tags/auth-container';
import CountingDown from '../tags/counting-down';
import UserAuth from '../../services/userAuth';
import Util from "../../services/util";
import { SessionStorageKeys } from '../../services/sessionStorageKeys.const';
import FeatureSettingsService from '../../services/featureSettingsService';
import { featureFlags } from '../../services/featureFlags.const';
import NavigationService from '../../services/navigation';

export class PhoneAuth extends Component {
    constructor() {
        super();
        this.mfaTimeout = sessionStorage.getItem(SessionStorageKeys.mfaTimeout);
        this.state = {
            isMobile: Util.isMobile(),
            phoneCode: '',
            activationError: '',
            activateButtonLoading: false,
            activateButtonDisabled: true
        }
    }

    componentDidMount() {
        document.title = 'Enter code | workplace_';
        this.props.pollingTimer();
        this.props.focusById('phoneCode');
    }

    enterCode = e => {
        this.setState({
            phoneCode: e.target.value,
            activateButtonDisabled: false
        });
        if (!e.target.value) {
            this.setState({
                activateButtonDisabled: true
            });
        }
    };

    timeoutAction = () => {
        this.props.goToPage('/');
    };

    submitPhoneCode = () => {
        if (this.state.activateButtonLoading) {
            console.log('Loading...');
        } else {
            this.setState({ activationError: '', activateButtonLoading: true });
            const { phoneCode } = this.state;
            return UserAuth.submitSmsCode(phoneCode, sessionStorage.getItem(SessionStorageKeys.mfaType)).then(response => {
                this.setState({ activationError: '' });
                const data = response.data;
                if (data) {
                    const mfaData = {
                        mfa: data
                    };
                    this.props.mfaRedirection(mfaData);
                } else {
                    return this.processRedirection(data);
                }
            }, error => {
                this.setState({
                    activationError: error.response.data,
                    activateButtonLoading: false
                });
            });
        }
    };

    submitForm = e => {
        e.preventDefault();
        this.submitPhoneCode();
    };

    processRedirection = data => {
     return  FeatureSettingsService.init().then(() => {
            if (FeatureSettingsService.isFeatureEnabled(featureFlags.FrictionlessOnboardingEnabled)) {
                this.props.requireNativeAppInstall(data);
                return;
            }

            this.props.processOnboardingV3Redirection(() => {
                this.props.requireNativeAppInstall(data, this.setState.bind(this, {
                    activationError: 'Server error. Please try later.',
                    activateButtonLoading: false
                }));
            });
        });
    }

    render({loginPageHeaderUrl, helpInfo, renderHelpLink}, {isMobile, phoneCode, activationError, activateButtonLoading, activateButtonDisabled}) {
        if (!this.mfaTimeout) {
            this.props.goToPage('/');
            return;
        }

        return (
            <div>
                {isMobile ? (
                    <x-mobile>
                        <section className='mobile-phone-auth'>
                            <Link to='/'>
                                <img src={loginPageHeaderUrl || 'img/blank-header-image.gif'} className='login-header-image'
                                     alt='login-bg'/>
                            </Link>
                            <div className='form'>
                                <form role='form' onSubmit={this.submitForm}>
                                    <p className='login-error'>{activationError} &nbsp;</p>
                                    <p>Please enter the code we sent to your phone below.</p>
                                    <div className='form-group clearfix'>
                                        <input
                                            name='phoneCode'
                                            className='form-control'
                                            id='phoneCode'
                                            required
                                            type='text'
                                            placeholder='Enter security code'
                                            value={phoneCode}
                                            onInput={this.enterCode}
                                        />
                                    </div>
                                    <div className='form-group clearfix notice'>
                                        <p id='notice'>
                                            This code will auto-destruct in <CountingDown timeout={this.mfaTimeout}
                                                                                          action={this.timeoutAction}
                                                                                          ssItem='mfaTimeout'/>.
                                        </p>
                                    </div>
                                    <div className='form-submit clearfix'>
                                        <a className={`button button-prime activateBtn pull-right ${activateButtonLoading ? 'loading' : ''} ${activateButtonDisabled ? 'disabled' : ''}`}
                                           onClick={this.submitPhoneCode}>{activateButtonLoading ? 'Please wait' : 'Activate'}</a>
                                        <input type='submit' className='hidden-submit-input'/>
                                    </div>
                                </form>
                                <div className='help-link'>
                                    {renderHelpLink('', false)}
                                </div>
                            </div>
                        </section>
                    </x-mobile>
                ) : (
                    <x-desktop>
                        <section className='auth-modal-container phone-auth'>
                            <Link to='/'>
                                <img src={loginPageHeaderUrl || 'img/blank-header-image.gif'} className='login-header-image'
                                     alt='login-bg'/>
                            </Link>
                            <div className='form'>
                                <form role='form' onSubmit={this.submitForm}>
                                    <p>Please enter the code we sent to your phone below.</p>
                                    <div className='form-group clearfix'>
                                        <label htmlFor='phoneCode'>Security code:</label>
                                        <input
                                            name='phoneCode'
                                            className='form-control'
                                            id='phoneCode'
                                            required
                                            type='text'
                                            placeholder=''
                                            value={phoneCode}
                                            onInput={this.enterCode}
                                        />
                                    </div>
                                    <div className='form-group notice'>
                                        This code will auto-destruct in <CountingDown timeout={this.mfaTimeout}
                                                                                      action={this.timeoutAction}
                                                                                      ssItem='mfaTimeout'/>.
                                    </div>
                                    {activationError ? <p className='login-error'>{activationError}</p> : <p className='login-error'>&nbsp;</p>}
                                    <div className='form-submit clearfix'>
                                        {renderHelpLink('', false)}
                                        <a className={`button button-prime activateBtn ${activateButtonLoading ? 'loading' : ''} ${activateButtonDisabled ? 'disabled' : ''}`}
                                           onClick={this.submitPhoneCode}>{activateButtonLoading ? 'Please wait' : 'Activate'}</a>
                                        <input type='submit' className='hidden-submit-input'/>
                                    </div>
                                </form>
                            </div>
                        </section>
                    </x-desktop>
                )}
            </div>
        )
    }
}

export default authContainer(PhoneAuth);




// WEBPACK FOOTER //
// ./src/scripts/views/two-factor/phone-auth.js